// Supported countries for OneKite (MVP). Flag is an emoji; dial is the country calling code.
export const COUNTRIES = [
  { name: "Tanzania", code: "TZ", dial: "+255", flag: "🇹🇿" },
  { name: "Kenya", code: "KE", dial: "+254", flag: "🇰🇪" },
  { name: "Uganda", code: "UG", dial: "+256", flag: "🇺🇬" },
];

export const DEFAULT_DIAL = "+255";

export const dialByCountry = (name) => (COUNTRIES.find((c) => c.name === name) || COUNTRIES[0]).dial;
